import {
  calculateItemTotal,
  calculateVatTotal,
  calculateTotal,
} from "../orderCommons/index.js";

export const COLLABAGEDDON_VAT_PERCENTAGE = 20;

export const calculateCollabageddonPricing = (
  products: { price: number }[],
) => {
  const orderItems = products.map(({ price }) => ({ price, quantity: 1 }));
  const pricing = {
    orderItems,
    deliveryCharge: 0,
    discountAmount: 0,
    vatPercentage: COLLABAGEDDON_VAT_PERCENTAGE,
  };

  return {
    subTotal: calculateItemTotal(orderItems),
    taxAmount: calculateVatTotal(pricing),
    total: calculateTotal(pricing),
  };
};
